import type { MenuNode } from '@/api/system';

/** 工作区 key，与后端 sys_menu.workspace 对齐。 */
export type WorkspaceKey = 'app' | 'mall';

export interface WorkspaceDef {
  key: WorkspaceKey;
  name: string;
  desc: string;
  /** Element Plus 图标组件名（已全局注册）。 */
  icon: string;
}

/** 两个工作区定义（登录后选择页 + 顶部切换器共用）。 */
export const WORKSPACES: WorkspaceDef[] = [
  {
    key: 'app',
    name: 'App 后台',
    desc: 'C 端运营 · 用户 / 设备 / 社区 / 积分 / 活动 / 系统',
    icon: 'Iphone'
  },
  {
    key: 'mall',
    name: '官网后台',
    desc: '官网商城 · 商品 / 订单 / 素材',
    icon: 'Shop'
  }
];

const DEFAULT_WS: WorkspaceKey = 'app';

export function workspaceDef(key: string | null | undefined): WorkspaceDef {
  return WORKSPACES.find((w) => w.key === key) ?? WORKSPACES[0];
}

/** 菜单的 workspace 归一化（缺省/未知 → app）。 */
export function menuWorkspace(m: MenuNode): WorkspaceKey {
  return m.workspace === 'mall' ? 'mall' : DEFAULT_WS;
}
